module.exports = __webpack_public_path__ + "img/zhinengcangku.24b47acf.png";